export const getNumberType = number => {
  const numberWithoutCountryCode = number.replace('+61', '')
  const length = numberWithoutCountryCode.length
  if (
    ['1300', '13'].some(opt => numberWithoutCountryCode.startsWith(opt)) &&
    (length === 6 || length === 10)
  ) {
    return 'tollFree'
  } else if (
    ['4', '04'].some(opt => numberWithoutCountryCode.startsWith(opt)) &&
    (length === 9 || length === 10)
  ) {
    return 'mobile'
  } else if (numberWithoutCountryCode && (length === 10 || length === 9)) {
    return 'local'
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/utils/getNumberType.js